import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useFnol } from '../context';

import {
  STEP_SELECT_FNOL_TEMPLATE,
  STEP_ANSWER_QUESTIONS,
  STEP_CONTACT_INFORMATION,
  STEP_CONTACT_PARTNER,
  STEP_FNOL_RECIEVED,
  STEP_IDENTIFY_CUSTOMER,
  STEP_UPLOAD_FILE,
  STEP_SEND_FNOL,
  STEP_SELECT_FNOL_CATEGORY,
} from '../CONSTANTS';
import styled from 'styled-components';

const ProgressItem = ({ progressStep }) => {
  const { fnolCategories, step } = useFnol();

  const [noStep, setNoStep] = useState(1);

  const steps = [
    {
      step: fnolCategories.length === 1 ? 0 : 1,
      name: STEP_SELECT_FNOL_CATEGORY,
    },
    {
      step: fnolCategories.length === 1 ? 1 : 2,
      name: STEP_SELECT_FNOL_TEMPLATE,
    },
    { step: fnolCategories.length === 1 ? 2 : 3, name: STEP_IDENTIFY_CUSTOMER },
    { step: fnolCategories.length === 1 ? 2 : 3, name: STEP_CONTACT_PARTNER },
    { step: fnolCategories.length === 1 ? 3 : 4, name: STEP_ANSWER_QUESTIONS },
    {
      step: fnolCategories.length === 1 ? 4 : 5,
      name: STEP_UPLOAD_FILE,
    },
    {
      step: fnolCategories.length === 1 ? 5 : 6,
      name: STEP_CONTACT_INFORMATION,
    },
    { step: fnolCategories.length === 1 ? 6 : 7, name: STEP_SEND_FNOL },
    { step: fnolCategories.length === 1 ? 7 : 8, name: STEP_FNOL_RECIEVED },
  ];

  useEffect(() => {
    setNoStep(steps.find(s => s.name === step).step);
  }, [step]);

  return (
    <Item
      status={
        noStep === progressStep
          ? 'active'
          : noStep < progressStep
          ? 'waiting'
          : 'completed'
      }
    >
      <div>{progressStep}</div>
    </Item>
  );
};

ProgressItem.propTypes = {
  progressStep: PropTypes.number.isRequired,
};

export default ProgressItem;

const Item = styled.li`
  display: flex;
  justify-content: center;
  flex: 1;
  position: relative;

  div {
    display: flex;
    width: ${props => props.theme.progressBar[props.status].diameter};
    height: ${props => props.theme.progressBar[props.status].diameter};
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.progressBar[props.status].fontColor};
    font-size: ${props => props.theme.progressBar[props.status].fontSize};
    font-weight: ${props => props.theme.progressBar[props.status].fontWeight};
    background-color: ${props =>
      props.theme.progressBar[props.status].backgroundColor};
    border-radius: 50%;
    border: ${props => props.theme.progressBar[props.status].border};
    user-select: none;
    line-height: 1;
  }

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    top: calc(${props => props.theme.progressBar[props.status].diameter} / 2);
    width: 100%;
    height: 2px;
    background-color: #cfcfcf;
    z-index: -1;
  }

  &:last-child {
    &:after {
      content: none;
    }
  }
`;
